/**
 * WHAT THE STOP BUTTON SENDS, PER KIND.
 *
 * Escape stops claude, codex, cursor, agy, grok and muse mid-turn — the byte the ⌨ row's Esc
 * writes, and what the button has always sent. Hermes ignores it: measured on spark-244c
 * (2026-10-15, v0.22.2), Escape during a streamed answer and the answer simply went on;
 * Ctrl+C stopped it ("⚡ Interrupted during API call.") and left Hermes idle at its prompt.
 *
 * But Ctrl+C TWICE within two seconds makes Hermes EXIT — the agent would be gone, not
 * stopped. So for Hermes the button sends one Ctrl+C and then holds for three seconds:
 * a double tap, or a second press while the screen catches up, sends nothing.
 */
export interface StopKey {
  /** The bytes written to the agent's own pty. */
  bytes: string
  /** What the status line says after the press. */
  said: string
  /** How long the button stays quiet after a press, in ms (0 = no hold). */
  holdMs: number
}

const ESCAPE: StopKey = { bytes: '\x1b', said: 'Escape sent to the agent', holdMs: 0 }
const HERMES: StopKey = { bytes: '\x03', said: 'Ctrl+C sent to the agent', holdMs: 3000 }

/** `kind` is the idle poll's word (`claude-code`, `codex`, `hermes`, …). */
export function stopKeyFor(kind: string | null | undefined): StopKey {
  return kind === 'hermes' ? HERMES : ESCAPE
}
